import {useState, useEffect, useRef} from "react";
import clsx from "clsx";
import {useHistory} from "react-router-dom";
import {Formik} from "formik";
import * as Yup from "yup";
import {DashboardLayout} from "components/Layout";
import {SubmitButton} from "components/Button";
import {useActionCategoryOptions} from "hooks/SuperAdmin/ActionCategory";
import {useAddAction} from "hooks/SuperAdmin/Action";
import {useToast} from "hooks/useToast";
import {convertErrorMessageFormat} from "utils/converter";
import {BasicDropdown} from "components/Dropdown";

const FormSchemaValidation = Yup.object().shape({
	title: Yup.string().required("Nama tindakan wajib di isi"),
	actionCategoryId: Yup.number().required("Kategori tindakan wajib di isi"),
});
const FormInitialValues = {title: "", actionCategoryId: ""};

export function ActionAddPage() {
	const formikRef = useRef();
	const [actionCategoryOptions, setActionCategoryOptions] = useState([]);
	const {data: actionCategories} = useActionCategoryOptions();
	const {showToast} = useToast();
	const history = useHistory();
	const {mutate, isLoading} = useAddAction();
	const handleSubmit = formData => {
		mutate(formData, {
			onSuccess: () => {
				showToast("success", "Data berhasil ditambahkan", 3000);
				history.push("/tindakan");
			},
			onError: res => {
				showToast("error", convertErrorMessageFormat(res.response.status, res.response.data.message), null);
			},
		});
	};

	useEffect(() => {
		if (actionCategories?.success) {
			const dataActionCategory = actionCategories?.data?.rows?.map(actionCategory => ({
				value: actionCategory?.id + "",
				label: `${actionCategory?.title}`,
			}));

			setActionCategoryOptions([...dataActionCategory]);
			formikRef?.current.setFieldValue(`actionCategoryId`, dataActionCategory[0].value);
		}
	}, [actionCategories]);

	return (
		<DashboardLayout>
			<Formik
				initialValues={FormInitialValues}
				innerRef={formikRef}
				validationSchema={FormSchemaValidation}
				onSubmit={handleSubmit}>
				{({handleSubmit, handleBlur, handleChange, values, errors, touched, setFieldValue}) => (
					<div class="box-white setting-content h-100 no-border p24">
						<div class="d-flex justify-content-between flex-wrap align-items-center mb-4">
							<div class="ttl-20">Tambah Tindakan Baru</div>
						</div>

						<hr />

						<div class="text-bold mb-4">
							<a class="text-dark" style={{cursor: "pointer"}} onClick={() => history.push("/tindakan")}>
								<span class="icon-ico-back me-2" />
							</a>
							Daftar List Tindakan
						</div>

						<div class="row gx-2 mb-5">
							<div class="col-sm-6 col-6">
								<div class="setting-item">
									<label class="setting-label required">Kategori Tindakan</label>
									<BasicDropdown
										className={clsx(
											"form-control",
											errors?.actionCategoryId && "form-control-error",
										)}
										data={actionCategoryOptions}
										name="actionCategoryId"
										value={values?.actionCategoryId}
										onSelect={fieldValue => {
											setFieldValue("actionCategoryId", fieldValue);
										}}
									/>
									{errors.actionCategoryId && (
										<p className="form-error-item-message">{errors.actionCategoryId}</p>
									)}
								</div>
							</div>
							<div class="col-sm-6 col-6">
								<div class="setting-item">
									<label class="setting-label required">Nama Tindakan</label>
									<input
										class={clsx(
											"form-control",
											errors?.title && touched?.title && "form-control-error",
										)}
										disabled={isLoading}
										name="title"
										placeholder=""
										type="text"
										value={values?.title}
										onBlur={handleBlur}
										onChange={handleChange}
									/>
									{errors.title && touched?.title && (
										<p className="form-error-item-message">{errors.title}</p>
									)}
								</div>
							</div>
						</div>

						<div class="text-center my-3">
							<SubmitButton
								className="btn btn-orange d-inline-block mw-250"
								disabled={!FormSchemaValidation.isValidSync(values)}
								loading={isLoading}
								text="Simpan"
								onClick={handleSubmit}
							/>
						</div>
					</div>
				)}
			</Formik>
		</DashboardLayout>
	);
}
